import * as React from 'react'
import { Box, Button } from '@mui/material'

export function RecentlyCreated({
  recentlyCreated,
}: {
  recentlyCreated: { name: string; url: string }[]
}) {
  const [showRecentlyCreated, setShowRecentlyCreated] =
    React.useState<boolean>(true)

  if (!recentlyCreated.length) return null

  function asString(): string {
    return recentlyCreated.map((r) => `${r.name}: ${r.url}`).join('\n')
  }

  return (
    <Box style={{ border: 'solid 1px', padding: 6, margin: 4 }}>
      <Button onClick={() => setShowRecentlyCreated((prev) => !prev)}>
        Recently Created
      </Button>
      {showRecentlyCreated && (
        <Box>
          {recentlyCreated.map((r) => (
            <div key={r.url}>
              <b>
                <span style={{ padding: 2 }}>{r.name}</span>
              </b>
              <span style={{ padding: 2 }}>{r.url}</span>
            </div>
          ))}
          <Button onClick={() => navigator.clipboard.writeText(asString())}>
            Copy
          </Button>
        </Box>
      )}
    </Box>
  )
}
